import { EXTERNAL_URLS, FOOTER_URL } from "../../constants/urlStrings";
import { USER_INFO } from "../../constants/global.constants";
import { InstagramIcon, YoutubeIcon, LinkedInIcon } from "../../assets/icons";
// Social media links with their respective icons
export const SOCIAL_MEDIA_LINKS = [
  {
    href: EXTERNAL_URLS.linkedinURL,
    Icon: LinkedInIcon,
    id: "linkedin-icon-btn",
  },
  {
    href: EXTERNAL_URLS.instagramURl,
    Icon: InstagramIcon,
    id: "instagram-icon-btn",
  },
  { href: EXTERNAL_URLS.youtubeURL, Icon: YoutubeIcon, id: "youtube-icon-btn" },
];
export const FOOTER_LINKS = (t, language) => {
  const footerData = FOOTER_URL[language] || FOOTER_URL[USER_INFO.cultureName];
  return [
    { href: footerData.dupontUrl, text: t("footer.dupontCom") },
    { href: footerData.privacyUrl, text: t("footer.privacy") },
    {
      href: footerData.termsConditions,
      text: t("footer.legalNoticeUsageTerms"),
    },
    { href: footerData.a11yUrl, text: t("footer.ally") },
  ];
};
